import { useEffect, useMemo, useState } from 'react';
import { mostraAlertaError } from "../../../../componentes/alerts/sweetAlert";
import { AxiosPrivado } from "../../../../componentes/axios/Axios";
import { ErroresPeticion } from "../../../../componentes/axios/ErroresPeticion";
import Card from '../../../../componentes/contenedores/Card';
import { IdentificarEstacion } from '../../../../componentes/estacion/Estacion';
import Page from "../../../../componentes/plantilla/Page";
import { CajaVerificar, IngresosEgresosListar } from '../../../../configuracion/apiUrls';
import { useContextEmpleado } from '../../../../contexto/empleado/EmpleadoContext';
import { useContextUsuario } from '../../../../contexto/usuario/UsuarioContext';
import ModalEgreso from './ModalEgreso';
import ModalIngreso from './ModalIngreso';
import TablaIngresosEgresos from './TablaIngresoEgresos';
import moment from 'moment';
import { formatoFecha } from '../../../../configuracion/validaciones';

const HomeIngresoEgreso = () => {
    const { listaIngresosEgresos, ActualizarLista, setListaIngresosEgresos } = useContextEmpleado();
    const { usuario, token } = useContextUsuario();
    const [fechaFiltro, setFechaFiltro] = useState(formatoFecha(new Date()));
    const [fechaFiltroTemp, setFechaFiltroTemp] = useState(formatoFecha(new Date()));
    const [panelAbierto, setPanelAbierto] = useState(false);
    const [cajaId, setCajaId] = useState(null);

    const verificarYCargarCaja = async () => {
        try {
            const estacionDatos = await IdentificarEstacion();
            AxiosPrivado.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            const response = await AxiosPrivado.post(CajaVerificar, { estacionDatos });
            if (response.data.estado === "CE") {
                mostraAlertaError("La caja ya está cerrada. No se puede registrar datos");
                setCajaId(null);
                return;
            }
            const caja = response.data;
            setCajaId(caja.id);
            //mostraAlertaOk("Caja autenticada correctamente");
        } catch (error) {
            ErroresPeticion(error);
            setCajaId(null); // Asegurarse de que cajaId sea null si falla
            //console.error("Autenticación de caja fallida:", error);
        }
    };

    useEffect(() => {
        verificarYCargarCaja();
        ActualizarLista(IngresosEgresosListar, setListaIngresosEgresos);
    }, []);

    const datos = {
        titulo: {
            titulo: "",
            url: "/app/admin/cajeros/ingresosEgresos",
            tituloUrl: "Menú Pagos",
            nombreUrl: "Inicio",
        },
    };

    const ingresosEgresosFiltrados = useMemo(() => {
        let registros = listaIngresosEgresos;

        if (fechaFiltro) {
            const fechaDeseada = fechaFiltro;

            registros = registros.filter(p => {
                const fechaPagoFormateada = p.fecha ? formatoFecha(p.fecha) : null;
                return fechaPagoFormateada === fechaDeseada;
            });
        }

        return registros;
    }, [listaIngresosEgresos, fechaFiltro]);

    const handleFiltrar = () => {
        setFechaFiltro(fechaFiltroTemp);
        setPanelAbierto(false);
    };

    const handleReset = () => {
        setFechaFiltro(moment().format("YYYY-MM-DD"));
        setFechaFiltroTemp(moment().format("YYYY-MM-DD"));
        setPanelAbierto(false);
    };

    const renderFilterPanel = () => (
        <div className="mb-4 d-flex justify-content-between align-items-center">
            <div className="position-relative">
                <button
                    className={`btn ${panelAbierto ? "btn-danger" : "btn-primary"} d-flex justify-content-between align-items-center`}
                    onClick={() => setPanelAbierto(!panelAbierto)}
                    style={{
                        borderRadius: "6px",
                        padding: "6px 12px",
                        fontSize: "0.9rem",
                        minWidth: "140px",
                    }}
                >
                    <span className="d-flex align-items-center">
                        <i className="fas fa-filter mx-2"></i>
                        Filtros
                    </span>
                    <i className={`fas fa-chevron-${panelAbierto ? "up" : "down"}`}></i>
                </button>

                {panelAbierto && (
                    <div
                        className="position-absolute top-100 mt-2 bg-body border border-secondary-subtle text-body shadow"
                        style={{
                            minWidth: "240px",
                            right: 0,
                            borderRadius: "10px",
                            backgroundColor: "#fff",
                            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                            padding: "15px",
                            zIndex: 1050,
                        }}
                    >
                        <div className="form-group mb-3">
                            <label htmlFor="fechaFiltroInput" className="form-label fw-bold">Fecha</label>
                            <input
                                id="fechaFiltroInput"
                                type="date"
                                className="form-control form-control-sm"
                                value={fechaFiltroTemp}
                                onChange={(e) => setFechaFiltroTemp(e.target.value)}
                            />
                        </div>

                        <div className="d-flex justify-content-end">
                            <button className="btn btn-sm btn-primary mx-2" onClick={handleFiltrar}>
                                <i className="fas fa-filter mx-1"></i> Filtrar
                            </button>
                            <button className="btn btn-sm btn-secondary" onClick={handleReset}>
                                <i className="fas fa-sync-alt mx-1"></i> Reset
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );

    return (
        <Page datos={datos}>
            <Card>
                <div className="d-flex justify-content-between align-items-start mb-4">
                    <div className="d-flex gap-2">
                        <ModalIngreso
                            token={token}
                            ActualizarLista={ActualizarLista}
                            setListaIngresosEgresos={setListaIngresosEgresos}
                            usuario={usuario}
                            cajaId={cajaId}
                            setCajaId={setCajaId}
                            verificarYCargarCaja={verificarYCargarCaja}
                        />
                        <ModalEgreso
                            token={token}
                            ActualizarLista={ActualizarLista}
                            setListaIngresosEgresos={setListaIngresosEgresos}
                            usuario={usuario}
                            cajaId={cajaId}
                            setCajaId={setCajaId}
                            verificarYCargarCaja={verificarYCargarCaja}
                        />
                    </div>
                    {renderFilterPanel()}
                </div>
                <TablaIngresosEgresos datos={ingresosEgresosFiltrados} />
            </Card>
        </Page>
    );
};

export default HomeIngresoEgreso;